import React from "react";
import dbnoData from "../../../../images/dashboardNODATA.png";

function ChartFallbackImg({ titleText }) {
  return (
    <div >
      {/* Custom Title Visible Only When No Data */}
      <div
        style={{
          width: "100%",
          textAlign: "center",
          fontSize: "20px",
          fontFamily: "'Host Grotesk', sans-serif",
          color: "#2c4e80",
          margin: "24px 0 12px 0",
          zIndex: 2,
          
        }}
      >
        {titleText || ""}
      </div>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
        }}
      >
        <img
          src={dbnoData}
          style={{
            maxWidth: "400px",
            maxHeight: "400px",
            objectFit: "contain",
            opacity: 0.8,
          }}
          alt="No data"
        />
      </div>
    </div>
  );
}

export default ChartFallbackImg;
